import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export default function useDevice() {
  const $ = _c(7);
  const [dpr, setDpr] = useState(1);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const updateDevice = () => {
        setDpr(window.devicePixelRatio || 1);
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      };
      setIsTouchDevice(navigator.maxTouchPoints > 0 || "ontouchstart" in window);
      updateDevice();
      window.addEventListener("resize", updateDevice);
      return () => window.removeEventListener("resize", updateDevice);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== dpr || $[3] !== height || $[4] !== isTouchDevice || $[5] !== width) {
    t2 = {
      dpr,
      width,
      height,
      isTouchDevice
    };
    $[2] = dpr;
    $[3] = height;
    $[4] = isTouchDevice;
    $[5] = width;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}